import { render, staticRenderFns } from "./IntegrationCheck.vue?vue&type=template&id=966c5a5c&scoped=true&"
import script from "./IntegrationCheck.vue?vue&type=script&lang=js&"
export * from "./IntegrationCheck.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationCheck.vue?vue&type=style&index=0&id=966c5a5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966c5a5c",
  null
  
)

export default component.exports